/** Ids of a component block and of every component nested in it (columns children). */
export function componentIds(block) {
    if (block.type !== "component")
        return [];
    const ids = block.id ? [block.id] : [];
    for (const child of block.children ?? [])
        ids.push(...componentIds(child));
    return ids;
}
/**
 * Build the outline: one item per top-level heading, carrying the ids of the components that
 * sit under it until the next heading of the same or higher level (so an H2 also lists the
 * components of its H3 subsections).
 */
export function buildOutline(blocks) {
    const items = [];
    const open = [];
    for (const block of blocks) {
        if (block.type === "heading") {
            while (open.length && open[open.length - 1].depth >= block.depth)
                open.pop();
            const item = { id: block.id, depth: block.depth, text: block.text, blockIds: [] };
            items.push(item);
            open.push(item);
        }
        else if (block.type === "component") {
            const ids = componentIds(block);
            for (const o of open)
                o.blockIds.push(...ids);
        }
    }
    return items;
}
//# sourceMappingURL=outline.js.map